import { Login, LoginForm } from "react-admin";

const CustomLoginForm = (props) => (
  <div>
    <LoginForm {...props} />
  </div>
);

const CustomLoginPage = (props) => (
  <Login loginform={<CustomLoginForm />} {...props} />
);

export default CustomLoginPage;
